import React, { useState } from 'react';
import { Button, TextField, Typography, Box, IconButton, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle  } from '@mui/material';
import AddCircleOutlineIcon from '@mui/icons-material/AddCircleOutline';
import RemoveCircleOutlineIcon from '@mui/icons-material/RemoveCircleOutline';
import API_URL from '../common/Apiurl';

function DynamicOptions({questionsList , industry_id}) {
  const apiUrl = API_URL;
  
  const [questions, setQuestions] = useState(questionsList);
  
  const [successMessages, setSuccessMessages] = useState([]);
  
  const [openDialog, setOpenDialog] = useState(false);
  
  const [removeIndex, setRemoveIndex] = useState(-1);
  
  const [removeOptionIndex, setRemoveOptionIndex] = useState(-1);

  const [optionIdToRemove, setOptionIdToRemove] = useState(-1);

  // console.log(questionsList, "questions", industry_id);
  
  const addIndustryQuestions = async() =>{
    try {
        console.log(questions);
        // return
        const postData={
            id: industry_id,
            questions: questions
        }
        const result = await fetch(`${apiUrl}/admin/addOptions`,{
            method: "POST",
            headers:{
                "Content-Type":"application/json",
                "Accept":"application/json"
            },
            body:JSON.stringify(postData) 
        });
        const data = await result.json();
        if((data.status === 200)){
            const newSuccessMessage = data.message;
            setSuccessMessages([...successMessages, newSuccessMessage]);
        }else if((data.status === 400)){
            const newSuccessMessage = data.message;
            setSuccessMessages([...successMessages, newSuccessMessage]);
        }
        if(data.status !== 200){
            throw new Error('Data not found');
        }
    }
    catch(error){
        console.log('Error: ', error)
    }
  }
  const addQuestion = () => {
    setQuestions([...questionsList, { questions: '', options: [{
      option:""
    }] }]);
  };

  const handleOptionChange = (optionIndex, event, option) => {
    console.log(optionIndex, event.target.value, option);
    if (option.id) {
      const updatedQuestions = [...questions];
      option.option = event.target.value
      updatedQuestions[optionIndex] = option;
      setQuestions(updatedQuestions);
    } else {
      const updatedQuestions = [...questions];
      updatedQuestions[optionIndex] = { option: event.target.value };
      setQuestions(updatedQuestions);
    }
    console.log(questions);
  };

  const addOption = () => {
    const updatedQuestions = [...questions];
    updatedQuestions.push({option:""});
    setQuestions(updatedQuestions);
  };

  const handleCloseDialog = () => {
    setOpenDialog(false);
    setRemoveIndex(-1);
    setRemoveOptionIndex(-1);
  };

  const handleClickRemoveOption = (optionIndex, option) => {
    // setRemoveIndex(questionIndex);
    setRemoveOptionIndex(optionIndex);
    // console.log(option);
    if (option && option.id) { 
      setOptionIdToRemove(option.id)
    }
    setOpenDialog(true);
  };

  const handleRemove = async () => {
    if (removeOptionIndex !== -1) {
      const updatedQuestions = [...questions];
      updatedQuestions.splice(removeOptionIndex, 1);
      setQuestions(updatedQuestions);
    } else {
      const updatedQuestions = [...questions];
      updatedQuestions.splice(removeIndex, 1);
      setQuestions(updatedQuestions);
    }
    const result = await fetch(`${apiUrl}/admin/deleteOption`,{
        method: "DELETE",
        headers:{
            "Content-Type":"application/json",
            "Accept":"application/json"
        },
        body:JSON.stringify({
          id: optionIdToRemove
        })
    });
    setOpenDialog(false);
    setRemoveIndex(-1);
    setRemoveOptionIndex(-1);
  };
  return (
    <div>
      <Typography variant="h5" gutterBottom>
        Dynamic Options
      </Typography>
      {questions.map((option, optionIndex) => (
            <div key={optionIndex} style={{ display: 'flex', alignItems: 'center', marginTop: '8px' }}>
              <TextField
                fullWidth
                variant="outlined"
                size="small"
                label={`Option ${optionIndex + 1}`}
                value={option.option}
                onChange={(e) => handleOptionChange(optionIndex, e, option)}
              />
              <IconButton onClick={() => handleClickRemoveOption(optionIndex, option)} size="small">
                <RemoveCircleOutlineIcon />
              </IconButton>
            </div>
          ))}
          <Button variant="outlined" onClick={() => addOption()} sx={{ marginTop: 1, marginRight: 1 }}>
            Add Option
          </Button>
       
      <Button
        onClick={addIndustryQuestions}
        variant="contained"
        color="success"
        sx={{ marginLeft: 2 }}
      >
        Submit to add options
      </Button>
      <Dialog
        open={openDialog}
        onClose={handleCloseDialog}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">Confirm</DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            Are you sure you want to remove this {removeOptionIndex !== -1 ? 'option' : 'question'}?
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleCloseDialog} color="primary">
            Cancel
          </Button>
          <Button onClick={handleRemove} autoFocus>
            Yes
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
}

export default DynamicOptions;
